import Random from "rung/src/random";
import Glyphs from "../glyphs";
import Entity from "./entity";
import Speed from "./speed";
import Mass from "./mass";
import Health from "./health";
import Equipment from "./equipment";
import Weapons from "./weapons";
import Armor from "./armor";
import Role from "./role";
import Statblock from "./statblock";
import * as actions from "./actions";

const rng = new Random(Math.random);

function logEvent(message) {
  document.dispatchEvent(new CustomEvent("game.event", {
    detail: {
      message,
    }
  }));
}

class Player extends Entity {
  static create() {
    return new Player(null, null, Glyphs.Player, "Player", {
      mass: new Mass(Mass.Medium),
      speed: new Speed(10),
      health: new Health(24),
      stats: new Statblock(12, 12, 12),
      equipment: Equipment.blankSheet(),
      role: Role.startingClass()
    });
  }

  constructor(x, y, glyph, name, components) {
    super(x, y, glyph, name, components);
    this.command = false;
    this.currentStory = false;
  }

  get epithet() {
    return `${this.equipment.quality} ${this.role.title}`;
  }

  isPlayer() {
    return true;
  }

  canTakeTurn() {
    return true;
  }

  isRangedWeaponEquipped() {
    return this.equipment.isRangedWeaponEquipped();
  }

  needsInput() {
    return this.command === false && this.currentStory === false;
  }

  takeTurn(stage) {
    switch (this.command.action) {
      case "Rest":
        actions.restAction(this, this.command, stage);
      break;

      case "Move":
        //console.log(`takeTurn: ${this.name} is moving`);
        actions.moveAction(this, this.command, stage);
      break;

      case "RangedAttack":
        //console.log(`takeTurn: ${this.name} is launching ranged attack`);
        actions.fireAction(this, this.command.detail.target, stage);
      break;

      case "Get":
        actions.getAction(this, this.command.detail, stage);
      break;

      case "Drop":
        actions.dropAction(this, this.command.detail, stage);
      break;
    }

    this.command = false;

    return !this.health.isDead();
  }

  gazeFrom(giant, distance) {
    const toughness = this.stats.toughnessModifier;
    const mirrorBonus = this.equipment.isMirrorEquipped() ? 5 : 0;
    const difficultyCheck = 20 - distance - mirrorBonus;
    const savingThrow = toughness + mirrorBonus + rng.integer(1, 21);

    if (savingThrow >= difficultyCheck) {
      logEvent("A horrible stone chill ripples across your flesh");

      if (this.equipment.isMirrorEquipped()) {
        const reflectedDamage = (savingThrow - difficultyCheck) * (11 - distance);
        console.log(`reflected damage: ${reflectedDamage}`);
        giant.health.hp -= reflectedDamage;

        logEvent("You hold the mirror up and reflect the Gorgon Giant’s gaze back at itself");

        if (giant.health.hp <= 0) {
          document.dispatchEvent(new CustomEvent("ui.transition", {
            detail: {
              command: "CompleteScreen"
            }
          }));
        }


      }
    } else {
      // Kill player and trigger UI event.
      document.dispatchEvent(new CustomEvent("ui.transition", {
        detail: {
          command: "DeathScreen",
          message: "The petrifying gaze of the Gorgon Giant turned you to stone."
        }
      }));
    }
  }

  pushCommand(command) {
    this.command = command;
  }

  pushStory(story) {
    this.currentStory = story;
  }

  popStory() {
    const story = this.currentStory;
    this.currentStory = false;
    return story;
  }
}

export default Player;
